export default "__VITE_ASSET__DGZOdCFY__"